import { ReactNode } from 'react';

export const StatusMessage = ({
  isSubmitError,
  isActive,
  errorMessage,
  loadingContent,
  finishedContent,
}: {
  isSubmitError: boolean;
  isActive: boolean;
  errorMessage: string;
  loadingContent: ReactNode;
  finishedContent: ReactNode;
}) => {
  if (isSubmitError) return <>{errorMessage}</>;
  if (isActive) return <>{loadingContent}</>;
  return <>{finishedContent}</>;
};
